module.exports = {
  footerText: 'Copyright Memoire Hamper © 2019',
}
